import type {Observable} from 'rxjs';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import Plan from 'web-app/react/entities/plans/model';

import type {CreateUpdatePlanPayload} from './types/manage-plan-types';
import type {CreateUpdatePlanOptions, DeletePlanResponse} from './types/api-types';

export const createPlan = (
    plan: CreateUpdatePlanPayload,
    preview: boolean = false,
    options?: CreateUpdatePlanOptions,
) => {
    return RESTClient.postAuthenticatedObservable(`v2/plans?preview=${preview}&version=2`, {plan}, options).map(
        response => {
            return {
                plan: Plan.fromAPI(response.plan),
            };
        },
    );
};

export const updatePlan = (
    plan: CreateUpdatePlanPayload,
    oldId: string,
    preview: boolean = false,
    options?: CreateUpdatePlanOptions,
) => {
    return RESTClient.putAuthenticatedObservable(`v2/plans/${oldId}?preview=${preview}&version=2`, {plan}, options).map(
        response => {
            return {
                plan: Plan.fromAPI(response.plan),
            };
        },
    );
};

export const deletePlan = (planId: string): Observable<DeletePlanResponse> => {
    return RESTClient.deleteAuthenticatedObservable(`v2/plans/${planId}?version=2`);
};

export const deletePlanDryRun = (planId: string): Observable<DeletePlanResponse> => {
    return RESTClient.deleteAuthenticatedObservable(`v2/plans/${planId}?dryRun=true`);
};
